<template>
  <div class="stats-collection">
    <div class="icon" v-if="icon">
      <i class="material-icons" v-html="icon"></i>
    </div>
    <div v-for="item in items"
         class="item"
         :key="item.label"
    >
      <div class="title">{{ item.label }}</div>
      <div class="subtitle">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    icon: String,
    items: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.stats-collection {
  display: flex;
  flex: 0 0 3.625rem;
  background-color: rgba($black, .04);
  border-bottom: solid 1px rgba($black, .08);

  .icon {
    height: 3.625rem;
    width: 3.625rem;
    background-color: rgba($black, .04);
    color: rgba($black, .87);

    i {
      font-size: 1rem;
    }
  }
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  padding: .5rem;
  padding-left: 1.375rem;
  border-left: solid 1px rgba($black, .08);
  min-width: 0;
}

.title {
  font-size: $size-small;
  line-height: 1.33;
  color: rgba($black, .5);
}

.subtitle {
  font-size: .875rem;
  color: rgba($black, .87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
